import * as React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}

LinearProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate and buffer variants.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired,
};

export default function LinearWithValueLabel({ val, total = 4 }) {
    // Calcul du pourcentage basé sur la valeur et le total
    const percentage = (Number(val) || 0) / total * 100;
    // Validation et arrondi du pourcentage (entre 0 et 100)
    const validatedValue = Math.min(100, Math.max(0, Math.round(percentage)));

    return (
        <Box sx={{ width: '100%' }}>
            <LinearProgressWithLabel value={validatedValue} />
        </Box>
    );
}

LinearWithValueLabel.propTypes = {
    val: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    total: PropTypes.number,
};